import { identity } from 'lodash-es';
import { createSelector } from 'reselect';

const getCompanyInfoFormInitialValues = (companyInfo: any) => companyInfo;

const companyInfoFormInitialValuesSelector = createSelector(getCompanyInfoFormInitialValues, identity);

export default companyInfoFormInitialValuesSelector;
